













































import { Component, Prop, Vue } from 'vue-property-decorator'
import { QuestionOption } from '@shared/types/graphql'
import { Question } from '@/store/modules/survey-store-module'
import { Icon } from '@alpha/ink'
import A from '@/utilities/alpha'
import store from '@/store'
import icoLookup from '@/utilities/ico-lookup'
import { sharedViewRouteName } from '@/router'
import VariantTitleEditor from '../VariantTitleEditor.vue'

export enum DefaultLabelMap {
  'Variant A',
  'Variant B',
  'Variant C',
  'Variant D',
}
@Component({
  components: {
    VariantTitleEditor,
    Icon
  }
})
export default class VariantQuestion extends Vue {
  @Prop({ required: true }) question!: Question

  variantTitleEditModes: Record<string, boolean> = {}

  get questionOptions () {
    return this.question.options!.sort((a, b) => (a.order > b.order) ? 1 : -1)
  }

  get urlImage () {
    return icoLookup.url
  }

  getVariantLabel (option: QuestionOption, index: number) {
    if (this.optionConfigs[option.id]?.title) {
      return this.optionConfigs[option.id].title
    } else if (option.label) {
      return option.label
    } else {
      return DefaultLabelMap[index]
    }
  }

  get identicalOptionText () {
    return this.question.options!.every(option => A.stripHTML(option.text) === A.stripHTML(this.question.options![0].text))
  }

  getOptionText (option: QuestionOption) {
    return A.stripHTML(option.text.replace(/<br\s*\/?>/mg, ' '))
  }

  setVariantTitleMode (optionId: string, isOn: boolean) {
    this.$set(this.variantTitleEditModes, optionId, isOn)
  }

  get optionConfigs () {
    return store.state.surveyConfiguration.optionConfigs
  }

  get publicView () {
    return this.$route.name === sharedViewRouteName
  }
}
